import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { useContextData } from "@/components/Context";

export function Main({ children, className }: { children: ReactNode; className?: string }) {
  const { isNavbarHidden } = useContextData();

  return (
    <div className={cn(
      "flex flex-col md:w-full",
      isNavbarHidden ? "w-full max-w-none px-4" : "sm:container xl:max-w-screen-xl",
      className
    )}>
      <main className="flex flex-col gap-4 flex-1 p-4 px-0 sm:px-4">
        {children}
      </main>
    </div>
  )

}